<div style="margin: 10px 10px 10px 10px;">
  <form [formGroup]="form">
    <div class="form-group row mb-3">
      <div class="uv-row">
        <span class="col-lg-3">&nbsp;</span>
        <span class="col-lg-2">Campus:</span>
        <div class="col-lg-3">
          <select class="form-control" [formControl]="campusName" (change)="onCampusChanged()">
            @for (cName of campusNames; track cName) {
              <option value="{{cName}}">{{cName}}</option>
            }
          </select>
        </div>
      </div>
    </div>
    <div class="form-group row mb-3">
      <div class="uv-row">
        <span class="col-lg-3">&nbsp;</span>
        <span class="col-lg-2">Building:</span>
        <div class="col-lg-3 ">
          <select class="form-control" [formControl]="buildingName">
            @for (bName of buildingNames; track bName) {
              <option value="{{bName}}">{{bName}}</option>
            }
          </select>
        </div>
      </div>
    </div>
    <div class="form-group row mb-3">
      <div class="uv-row">
        <span class="col-lg-3">&nbsp;</span>
        <span class="col-lg-2">Jack Label:</span>
        <div class="col-lg-3">
          <input type="text" class="form-control" [formControl]="jackLabel" />
        </div>
      </div>
    </div>
    <div class="form-group row mb-3">
      <div class="uv-row">
        <span class="col-lg-3">&nbsp;</span>
        <span class="col-lg-2">&nbsp;</span>
        <div class="col-lg-2" style="height: 60px; display: flex; justify-content: center; align-items: center;">
          <button [disabled]="!enableLookup" type="button" pButton label="Lookup" (click)="lookup()"></button>
        </div>
        <div class="col-lg-2" style="height: 60px; display: flex; justify-content: left; align-items: center;">
          <input type="checkbox" [formControl]="doLive" />
          <span class="uv-checkbox-label">Live</span>
        </div>
      </div>
    </div>
    <div class="form-group row mb-3">
      <div class="uv-row">
        <span class="col-lg-3">&nbsp;</span>
        <span class="col-lg-2">Jack Room:</span>
        <div class="col-lg-3">
          <input type="text" class="form-control" [value]="jackRoom" readonly />
        </div>
      </div>
    </div>
    <div class="form-group row mb-3">
      <div class="uv-row">
        <span class="col-lg-3">&nbsp;</span>
        <span class="col-lg-2">Switch Name:</span>
        <div class="col-lg-3">
          <input type="text" class="form-control" [value]="switchName" readonly />
        </div>
      </div>
    </div>
    <div class="form-group row mb-3">
      <div class="uv-row">
        <span class="col-lg-3">&nbsp;</span>
        <span class="col-lg-2">Switch IP Address:</span>
        <div class="col-lg-3">
          <input type="text" class="form-control" [value]="ipAddress" readonly />
        </div>
      </div>
    </div>
    <div class="form-group row mb-3">
      <div class="uv-row">
        <span class="col-lg-3">&nbsp;</span>
        <span class="col-lg-2">Slot/Module:</span>
        <div class="col-lg-3">
          <input type="text" class="form-control" [value]="slotModule" readonly />
        </div>
      </div>
    </div>
    <div class="form-group row mb-3">
      <div class="uv-row">
        <span class="col-lg-3">&nbsp;</span>
        <span class="col-lg-2">Port:</span>
        <div class="col-lg-3">
          <input type="text" class="form-control" [value]="port" readonly />
        </div>
      </div>
    </div>
    <div class="form-group row mb-3">
      <div class="uv-row">
        <span class="col-lg-3">&nbsp;</span>
        <span class="col-lg-2">VLAN:</span>
        <div class="col-lg-3">
          <input type="text" class="form-control" [value]="vlan" readonly />
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="uv-row">
        <span class="col-lg-3">&nbsp;</span>
        <span class="col-lg-2">Connected:</span>
        <div class="col-lg-3">
          <textarea rows="5" cols="50" class="form-control" [value]="connected" readonly></textarea>
        </div>
      </div>
    </div>
  </form>
</div>